// eslint-disable-next-line no-undef
@Inject('appFactory')
class WidgetService {
  initConfig({ configName }) {
    const widgetConfig = this.appFactory.deps.config.widgetConfig[configName] ? this.appFactory.deps.config.widgetConfig[configName].split(',') : undefined;

    const isAvailableField = (field) => (widgetConfig ? widgetConfig.includes(field) : true);

    return {
      isAvailableField,
    };
  }
}

export default WidgetService;



// WEBPACK FOOTER //
// ./src/modules/utils/widget/widget-service.js